/** Relative time in Polish, with the plural forms the language actually needs. */
export function relativeTime(iso: string, now = Date.now()): string {
  const seconds = Math.round((now - new Date(iso).getTime()) / 1000)

  if (seconds < 45) return 'przed chwilą'
  if (seconds < 90) return 'minutę temu'

  const minutes = Math.round(seconds / 60)
  if (minutes < 60) return `${minutes} ${plural(minutes, 'minutę', 'minuty', 'minut')} temu`

  const hours = Math.round(minutes / 60)
  if (hours < 24) return `${hours} ${plural(hours, 'godzinę', 'godziny', 'godzin')} temu`

  const days = Math.round(hours / 24)
  if (days === 1) return 'wczoraj'
  if (days < 7) return `${days} dni temu`

  const date = new Date(iso)
  const dd = String(date.getDate()).padStart(2, '0')
  const mm = String(date.getMonth() + 1).padStart(2, '0')
  return days < 365 ? `${dd}.${mm}` : `${dd}.${mm}.${date.getFullYear()}`
}

/** Polish picks a different form for 1, for 2–4 (excluding the teens), and for everything else. */
function plural(n: number, one: string, few: string, many: string): string {
  if (n === 1) return one
  const lastTwo = n % 100
  const last = n % 10
  if (last >= 2 && last <= 4 && !(lastTwo >= 12 && lastTwo <= 14)) return few
  return many
}
